import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

// import components
import InputField from '~/common/components/InputField';
import Tooltip from '~/common/components/Tooltip';

import info from '~/common/images/icon-info-tooltip.svg';

// Import Local Styles
import styles from './number-selector.css';

@inject('formsStore')
@observer
export default class LicenseSelector extends React.Component {
    constructor(props) {
        super(props);
    }
    updateLicenses(event) {
        this.props.formsStore.setOrganizers(event.target.value > 0 ? event.target.value : 1);
        this.props.formsStore.LicenseSelectorValidation();
    }
    incrementLicenses(event, direction) {
        const { LicenseSelector, MaxOrganizers } = this.props.formsStore;

        event.preventDefault();
        const value = direction === 'plus' ?
            (LicenseSelector < MaxOrganizers ? LicenseSelector + 1 : MaxOrganizers) :
            (LicenseSelector <= 1 ? 1 : LicenseSelector - 1);
        this.props.formsStore.setOrganizers(value);
        this.props.formsStore.LicenseSelectorValidation();
    }
    onBlurNumberSelector() {
        const { LicenseSelector, MaxOrganizers } = this.props.formsStore;

        if (LicenseSelector > MaxOrganizers) {
            this.props.formsStore.setOrganizers(MaxOrganizers);
        }
        this.props.formsStore.LicenseSelectorValidation();
    }
    render() {
        const { LicenseSelector, LicenseSelectorError, MaxOrganizers } = this.props.formsStore;
        return (
            <Fragment>
                <div className={styles.selector}>
                    <button className={`${styles.button} ${LicenseSelector === 1 ? styles.disabled : ''}`} onClick={(event) => { this.incrementLicenses(event, 'minus'); }}><span>&#8211;</span></button>
                    <InputField
                        allowedCharacters=" -'"
                        defaultValue={LicenseSelector.toString()}
                        focus={true}
                        id="license-number"
                        maxLength={2}
                        name="LicenseSelector"
                        onBlur={e => this.onBlurNumberSelector(e)}
                        onChange={e => this.updateLicenses(e)}
                        onKeyUp={e => this.updateLicenses(e)}
                        restrictCharacters="numericOnly"
                        type="number"
                        wrapperClass={styles['input-wrapper']}
                    />
                    <button className={`${LicenseSelector === 1 ? styles.animate : ''} ${styles.button} ${LicenseSelector === MaxOrganizers ? styles.disabled : ''}`} onClick={(event) => { this.incrementLicenses(event, 'plus'); }}><span>+</span></button>
                    <span className={styles.label}>{this.props.label}
                        <Tooltip content={this.props.tooltip}><img className={styles.icon} src={info} /></Tooltip>
                    </span>
                </div>
                {LicenseSelectorError && <div className={styles['error-message']} dangerouslySetInnerHTML={{ __html: LicenseSelectorError }} />}
            </Fragment>
        );
    }
}

LicenseSelector.propTypes = {
    currentLicenses: PropTypes.number
};
